import { render, staticRenderFns } from "./ControlButtons.vue?vue&type=template&id=a37a0bc4&"
import script from "./ControlButtons.vue?vue&type=script&lang=js&"
export * from "./ControlButtons.vue?vue&type=script&lang=js&"
import style0 from "./ControlButtons.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports